import {Command} from "./Command";
import {GamePlay} from "../model/game-play";
import {calculateYardLine} from "../helpers/distance";

export class CalculateYardLineCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private lastGamePlay: GamePlay
  ) { }

  execute() {
    if (this.lastGamePlay.distance === undefined) {
      throw new Error('GamePlay sans distance. Aucun calcul de la distance')
    }
    if (this.lastGamePlay.gnLs === undefined) {
      throw new Error('GamePlay sans gnLs')
    }

    this.gamePlay.yardLine = calculateYardLine(this.lastGamePlay.yardLine, this.lastGamePlay.gnLs)

    console.log('COMMAND CalculateYardLineCommand', this.gamePlay.yardLine)
  }
}
